@import "../../global/gx-ide-mixins.scss";

:host {
  display: inline-grid;
  justify-items: end;
  block-size: 100%;
}

.dropdown::part(expandable-button) {
  display: grid;
  grid-template-columns: max-content max-content max-content;
  align-items: center;
  gap: var(--spacing-gap-l);
  block-size: auto;
  cursor: pointer;
}
.user-login {
  &__details {
    display: grid;
    grid-template-rows: max-content max-content;
    gap: var(--spacing-gap-xs);
    justify-items: end;
  }
  &__name {
    font-weight: var(--font-style-semi-bold);
    font-size: var(--font-size-body-s);
    color: var(--color-text-neutral-default);
  }
  &__name,
  &__organization {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-inline-size: 120px;
    display: inline-block;
    line-height: 1 !important; // WA: Without overwriting the line-height, the text will be too high.
  }
  &__avatar {
    font-size: 9px;
    flex: 0 0 auto;
    display: flex;
    align-items: center;
    justify-content: center;
    block-size: 24px;
    inline-size: 24px;
    color: var(--color-text-neutral-default);
    border-radius: 50%;
    background-color: var(--color-accent-neutral-contrast);
    border: 1px solid var(--color-border-primary-on-default);
  }

  &__footer {
    display: flex;
    flex-direction: column;
    gap: var(--spacing-gap-m);
    @include button-reset();

    .agreement-link {
      text-decoration: underline;
      cursor: pointer; /* Ensure it still looks clickable */
    }
  }
}
